import { css } from '@/styled-system/css';

export const autocompleteContainerStyles = css.raw({
  position: 'relative',
  width: '100%',
  float: 'left',
  paddingBottom: '200',
  md: {
    flex: 1,
    marginRight: '400',
    paddingBottom: '0',
  },
});

export const dropdownStyles = css.raw({
  position: 'absolute',
  width: '100%',
  maxWidth: '100vw',
  zIndex: 100,
  maxHeight: '100vh',
  borderRadius: '0 0 {radii.100} {radii.100}',
  marginTop: '{spacing.-50}',
  paddingTop: '{spacing.50}',
  border: '1px solid {colors.border.subtle}',
  borderTop: 'none',
  textAlign: 'left',
});

export const dropdownItemStyles = css.raw({
  padding: { base: '0 18px', md: '0 {spacing.600}' },
  backgroundColor: 'bg.neutral',
  cursor: 'pointer',
  '& :last-of-type': {
    borderRadius: '0 0 3px 3px',
  },
  '& :last-of-type > *': {
    borderBottom: 'none',
  },
});

export const dropdownItemTextStyles = css.raw({
  width: 'calc(100% - 0px)',
  height: { base: '1200', md: '58px' },
  lineHeight: { base: '46px', md: '1400' },
  borderBottom: '1px solid {colors.border.subtle}',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
});
